import { render, staticRenderFns } from "./IdleVehiclePanel.vue?vue&type=template&id=2c830ec8&scoped=true"
import script from "./IdleVehiclePanel.vue?vue&type=script&lang=js"
export * from "./IdleVehiclePanel.vue?vue&type=script&lang=js"
import style0 from "./IdleVehiclePanel.vue?vue&type=style&index=0&id=2c830ec8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c830ec8",
  null
  
)

export default component.exports